var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
import { getFullName, isAlphaNumeric } from "healthex-common/utils";
import { NamedRoutes } from "./NamedRoutes";
import { NOT_LOADED } from "../Infra/RemoteData";
export class PatientsViewModel {
    constructor(container) {
        this.searchText = null;
        this.recentPatients = NOT_LOADED;
        this.isValidMRN = true;
        this.routingUIManager = container.routingUIManager;
        this.guidedConsentService = container.guidedConsentService;
        this.authManager = container.authManager;
        void this.loadRecentPatients();
    }
    get showRecentPatientsTable() {
        if (this.recentPatients === NOT_LOADED)
            return false;
        return this.recentPatients.length > 0;
    }
    get showFooter() {
        if (this.recentPatients === NOT_LOADED)
            return false;
        return !this.showRecentPatientsTable;
    }
    get showSpinner() {
        if (this.recentPatients === NOT_LOADED)
            return true;
    }
    get searchErrorText() {
        return this.isValidMRN ? undefined : "MRNs can only contain alphabet characters (a-z, A-Z) or numeric characters (0-9)";
    }
    updateSearchText(searchText) {
        this.searchText = searchText;
    }
    async search() {
        if (!this.searchText)
            return;
        this.isValidMRN = isAlphaNumeric(this.searchText);
        if (!this.isValidMRN)
            return;
        this.goToPostSearchResults(this.searchText);
    }
    goToPostSearchResults(mrn) {
        this.routingUIManager.navigateTo(NamedRoutes.PATIENTS_SEARCH, { mrn });
    }
    async loadRecentPatients() {
        if (this.authManager.orgId === null)
            return;
        const results = await this.guidedConsentService.getAllPatientGuidedConsentForOrganization(this.authManager.orgId);
        this.recentPatients = results.patients.map((recentPatient) => ({
            ...recentPatient,
            fullName: getFullName(recentPatient),
        }));
    }
    onRecentPatientRowClick(recentPatient) {
        this.goToPostSearchResults(recentPatient.mrn);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientsViewModel.prototype, "searchText", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientsViewModel.prototype, "recentPatients", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientsViewModel.prototype, "isValidMRN", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientsViewModel.prototype, "showRecentPatientsTable", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientsViewModel.prototype, "showFooter", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientsViewModel.prototype, "showSpinner", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientsViewModel.prototype, "searchErrorText", null);
